export interface IPlaceholderCellProps {
  colSpan: number;
}

export function PlaceholderCell({ colSpan }: IPlaceholderCellProps) {
  return <td colSpan={colSpan} style={{ height: 43 }}></td>
}
